// frontend/src/slices/adminSlice.js
import { createSlice } from '@reduxjs/toolkit';

const adminInfo = localStorage.getItem('adminInfo') 
    ? JSON.parse(localStorage.getItem('adminInfo'))
    : null;

const adminSlice = createSlice({
    name: 'admin',
    initialState: {
        loading: false,
        isAuthenticated: !!adminInfo,
        admin: adminInfo ? adminInfo.admin : null,
        error: null
    },
    reducers: {
        adminLoginRequest(state) {
            state.loading = true;
            state.error = null;
        },
        adminLoginSuccess(state, action) {
            state.loading = false;
            state.isAuthenticated = true;
            state.admin = action.payload.admin;
            state.error = null;
        },
        adminLoginFail(state, action) {
            state.loading = false;
            state.isAuthenticated = false;
            state.admin = null;
            state.error = action.payload;
        },
        loadAdminRequest(state) {
            state.loading = true;
            state.error = null;
        },
        loadAdminSuccess(state, action) {
            state.loading = false;
            state.isAuthenticated = true;
            state.admin = action.payload;
            state.error = null;
        },
        loadAdminFail(state, action) {
            state.loading = false;
            state.isAuthenticated = false;
            state.admin = null;
            state.error = action.payload;
        },
        clearError(state) {
            state.error = null;
        },
        adminLogout(state) {
            state.loading = false;
            state.isAuthenticated = false;
            state.admin = null;
            state.error = null;
        }
    }
});

export const {
    adminLoginRequest,
    adminLoginSuccess,
    adminLoginFail,
    loadAdminRequest,
    loadAdminSuccess,
    loadAdminFail,
    clearError,
    adminLogout
} = adminSlice.actions;

export default adminSlice.reducer;